var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-md-2 contact" }, [
        _c("h6", [
          _c("div", { staticClass: "contact-address" }, [
            _c("div", [_vm._v("OMyFu")]),
            _vm._v(" "),
            _c("div", [
              _vm._v("8051 " + _vm._s(_vm.$t("footer.contact.city")))
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("footer.contact.country")))]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-10" }, [
        _c("h6", [
          _c("div", { staticClass: "social-media-icons row" }, [
            _c("div", { staticClass: "col-lg-3 hidden-lg" }),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-auto icon-group-container" },
              [
                _c(
                  "span",
                  { staticClass: "social-media-single-icon" },
                  [
                    _c("social-sharing", {
                      attrs: {
                        url: "http://www.omyfu.com/",
                        quote: _vm.$t("footer.socialSharing.facebook")
                      },
                      inlineTemplate: {
                        render: function() {
                          var _vm = this
                          var _h = _vm.$createElement
                          var _c = _vm._self._c || _h
                          return _c(
                            "network",
                            { attrs: { network: "facebook", id: "fb-icon" } },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../assets/images/icons/fb_icon.png"),
                                  height: "36px"
                                }
                              })
                            ]
                          )
                        },
                        staticRenderFns: []
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "social-media-single-icon" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$t("footer.socialSharing.twitter"),
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/icons/twitter_icon.png"),
                          width: "36px"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "social-media-single-icon" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$t("footer.socialSharing.whatsapp"),
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/icons/whatsapp_icon.png"),
                          width: "36px"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "social-media-single-icon" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$t("footer.socialSharing.sms"),
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/icons/sms_icon.png"),
                          width: "36px"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "social-media-single-icon" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$t("footer.socialSharing.email"),
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/icons/email_icon.png"),
                          width: "36px"
                        }
                      })
                    ]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "legal" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h6", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.omyfu.com/imprint",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("footer.imprint")))]
                  ),
                  _vm._v(
                    "\n                                |\n                                "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://omyfu.com/disclaimer",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("footer.disclaimer")))]
                  ),
                  _vm._v(
                    "\n                                Copyright © 2019 OMyFu | " +
                      _vm._s(_vm.version) +
                      "\n                            "
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mail-to" }, [
      _c("a", { attrs: { href: "mailto:info@omyfu.com", target: "_top" } }, [
        _vm._v("info@omyfu.com")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-sm-auto icon-group-container" },
      [
        _c("span", { staticClass: "social-media-single-icon" }, [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://itunes.apple.com/us/app/omyfu/id1423062463?ls=1&mt=8",
                target: "_blank"
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("../assets/images/icons/app_store_badge_mustard.png"),
                  height: "40px"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "social-media-single-icon" }, [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://play.google.com/store/apps/details?id=com.omyfu.androidApp&hl=de",
                target: "_blank"
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("../assets/images/icons/google_play_badge_mustard.png"),
                  height: "40px"
                }
              })
            ]
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d6d62bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d6d62bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterComponent.vue
// module id = null
// module chunks = 